<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="lna-modal-header-title">
      <h4 class="modal-title">
        {{ 'components.changeReadingRoom.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="changeReadingRoom" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="lna-row full-width">
          <div class="label-wrapper">
            <label class="lna form-label" for="readingRoomId">
              {{ 'components.changeReadingRoom.readingRoomId' | translate }}
              <span class="required-field">*</span>
            </label>
          </div>
          <select [ngClass]="{ invalid: shouldRenderError('readingRoomId') }" formControlName="readingRoomId">
            <option [value]="null" disabled selected>
              {{ 'components.changeReadingRoom.selectReadingRoom' | translate }}
            </option>
            @for (readingRoom of readingRooms; track readingRoom.id) {
              <option value="{{ readingRoom.id }}">
                {{ readingRoom.name }}
              </option>
            }
          </select>
          @if (getErrorMessage('readingRoomId'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">
                {{ errorMessage | translate }}
              </small>
            </div>
          }
        </div>
        <div class="lna-row full-width">
          <div class="label-wrapper">
            <label class="form-label lna" for="reasonForReadingRoom">
              {{ 'components.changeReadingRoom.reasonForReadingRoom' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="reasonForArchive" />
          </div>
          <div class="textarea-wrapper">
            <textarea
              class="form-control lna"
              id="reasonForReadingRoom"
              [ngClass]="{ invalid: shouldRenderError('reasonForReadingRoom') }"
              type="text"
              formControlName="reasonForReadingRoom"
              name="reasonForReadingRoom"
              required
              maxlength="{{ maxFieldLength }}"></textarea>
            <p
              class="length"
              [ngClass]="{
                invalid: reasonForReadingRoom?.value.length > maxFieldLength
              }">
              {{ reasonForReadingRoom?.value.length }}/{{ maxFieldLength }}
            </p>
          </div>
          @if (getErrorMessage('reasonForReadingRoom'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">
                {{ errorMessage | translate }}
              </small>
            </div>
          }
        </div>
        <div class="lna-row full-width">
          <div class="label-wrapper">
            <label class="form-label lna" for="reasonForClient">
              {{ 'components.changeReadingRoom.reasonForClient' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-tooltip text="reasonForClient" />
          </div>
          <div class="textarea-wrapper">
            <textarea
              class="form-control lna"
              id="reasonForClient"
              [ngClass]="{ invalid: shouldRenderError('reasonForClient') }"
              type="text"
              formControlName="reasonForClient"
              name="reasonForClient"
              required
              maxlength="{{ maxFieldLength }}"></textarea>
            <p
              class="length"
              [ngClass]="{
                invalid: reasonForClient?.value.length > maxFieldLength
              }">
              {{ reasonForClient?.value.length }}/{{ maxFieldLength }}
            </p>
          </div>
          @if (getErrorMessage('reasonForClient'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">
                {{ errorMessage | translate }}
              </small>
            </div>
          }
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="submit()" type="button">
      {{ 'components.changeReadingRoom.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.changeReadingRoom.cancel' | translate }}
    </button>
  </div>
</ng-template>
